import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import {RouteDetailContext} from "./context/RouteDetailContext";
import {getRefreshInterval} from "../util/Util";
import {FormattedMessage} from "react-intl";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {getStationCode} from "../network/NetworkUtil";
import AlertView from "../alert/AlertView";
import {AR_V2} from "../util/Constants";
import RouteMetadataV2 from "./RouteMetadataV2";
import RouteMetadata from "./RouteMetadata";
import Column from "@amzn/meridian/column";

const RouteInfo = (props) => {
    const {dispatchRD} = useContext(RouteDetailContext)
    const {configViewModel} = useContext(CapabilityContext)

    const parseStationCode = (stationCode) => {
        if (stationCode && stationCode !== "NA") {
            return stationCode
        }
        return getStationCode();
    }

    const getRouteData = () => {
        dispatchRD({
            type: 'LOAD_VIEW',
            data: {
                routeId: props.route.routeId,
                routeStatus: props.route.status,
                dispatcher: dispatchRD,
                baseUrl: configViewModel.baseUrl,
                capability: configViewModel.capability,
                stationCode: parseStationCode(props.route.stationCode),
                stationConfig: configViewModel.stationConfig
            }
        });
    }

    useEffect(() => {
        getRouteData();
        const interval = setInterval(() => {
            getRouteData();
        }, getRefreshInterval(configViewModel.stationConfig));
        return () => clearInterval(interval);
    }, []);

    const goBack = () => {
        if (props.route.prevTab === "Pick") {
            props.history.push("/pick");
        } else if (props.route.prevTab === "PickAssociates") {
            props.history.push("/pickassociates");
        } else {
            let subUrl = "/station/dashboard";
            subUrl += "/" + (props.route.prevTab.toLowerCase());
            const url = new URL(configViewModel.baseUrl + subUrl);
            window.open(url.href, "_parent");
        }
    }

    const prevTabName = () => {
        if (props.route.prevTab === "Stage") {
            return <FormattedMessage id="routeInfo.stage" defaultMessage="Stage"/>
        } else if (props.route.prevTab === "Depart") {
            return <FormattedMessage id="routeInfo.depart" defaultMessage="Depart"/>
        } else if (props.route.prevTab === "Stow") {
            return <FormattedMessage id="routeInfo.stow" defaultMessage="Stow"/>
        } else if (props.route.prevTab === "PickAssociates") {
            return <FormattedMessage id="routeInfo.pickAssociate" defaultMessage="Pick Associates"/>
        } else {
            return <FormattedMessage id="routeInfo.pick" defaultMessage="Pick"/>
        }
    }

    return (
        <Column width="100%" spacingInset="large large small">
            <Row>
                <BreadcrumbGroup>
                    <Breadcrumb onClick={goBack}>
                        {prevTabName()}
                    </Breadcrumb>
                    <Breadcrumb>
                        <FormattedMessage id="routeInfo.routeDetails" defaultMessage="Route Details"/>
                    </Breadcrumb>
                </BreadcrumbGroup>
            </Row>
            <AlertView/>
            {configViewModel.capability === AR_V2 ?
                <RouteMetadata history={props.history} route={props.route}/>
                : <RouteMetadataV2 history={props.history} route={props.route}/>
            }
        </Column>
    );
}

export default RouteInfo


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/RouteInfo.js